import { Api } from '@/api/api';
import { TaskListRequestFilters } from '@/api/requests/tasks/task-list-request-filters';
import { TaskListResponse } from '@/api/responses/tasks/task-list-response';
import { TaskItem } from '@/shared/task-item';
import { TaskItemOutcome } from '../shared/task-item-outcome';

export class TaskApi extends Api {
    public async getTasksAsync(filters: TaskListRequestFilters | null = null): Promise<TaskListResponse> {
        return await this.getAsync<TaskListResponse>(`v1/task`, filters);
    }

    public async assignTaskAsync(taskId: string, userIds: Array<string>): Promise<string> {
        return await this.postAsync<string>(`v1/task/${taskId}/assign`, {
            taskId,
            users: userIds,
        });
    }

    public async createTaskOutcomeAsync(taskId: string, taskItemOutcome: TaskItemOutcome): Promise<string> {
        const url = this.buildUrl(`v1/task/${taskId}/outcome`);
        const location = await this.postAsync<string>(`v1/task/${taskId}/outcome`, taskItemOutcome);
        return location.replace(`${url}/`, ``);
    }

    public async updateTaskOutcomeAsync(taskId: string, taskItemOutcome: TaskItemOutcome): Promise<string> {
        const url = this.buildUrl(`v1/task/${taskId}/outcome/${taskItemOutcome.id!}`);
        const location = await this.putAsync<string>(`v1/task/${taskId}/outcome/${taskItemOutcome.id!}`, taskItemOutcome);
        return location.replace(`${url}/`, ``);
    }

    public async deleteTaskAsync(task: TaskItem): Promise<string> {
        return await this.deleteAsync<string>(`v1/task/${task.id}`);
    }

    public constructor() {
        super();
    }
}
